import { z } from 'zod';

import type {
  GetFixedIdAssetSnapshotRequest,
  GetFixedIdAssetSnapshotResponse,
  ListFixedIdAssetRegistryRequest,
  ListFixedIdAssetRegistryResponse,
} from './fixed-id-assets-queries.dto.js';
import {
  FixedIdAssetRegistryItemSchema,
  FixedIdAssetSnapshotSchema,
} from './fixed-id-assets.schema.js';

export const GetFixedIdAssetSnapshotRequestSchema: z.ZodType<GetFixedIdAssetSnapshotRequest> =
  z.object({
    companyId: z.uuid(),
    assetId: z.uuid(),
  });

export const GetFixedIdAssetSnapshotResponseSchema: z.ZodType<GetFixedIdAssetSnapshotResponse> =
  z.object({
    asset: FixedIdAssetSnapshotSchema,
  });

export const ListFixedIdAssetRegistryRequestSchema: z.ZodType<ListFixedIdAssetRegistryRequest> =
  z.object({
    companyId: z.uuid(),
    storeId: z.uuid().optional(),
    locationId: z.uuid().optional(),
    includeRetired: z.boolean().optional(),
    includeActiveOnly: z.boolean().optional(),
    availableOnly: z.boolean().optional(),
  });

export const ListFixedIdAssetRegistryResponseSchema: z.ZodType<ListFixedIdAssetRegistryResponse> =
  z.object({
    items: z.array(FixedIdAssetRegistryItemSchema),
  });
